<template>
  <div class="ls_spin_container">
    <div v-if="product_orders.data.length === 0" class="ls_empty_list">
      Документы отсутствуют
    </div>
    <div v-else>
      <Card v-for="doc in product_orders.data" :key="doc.id" class="card-container" style="margin-bottom: 15px">
        <Row>
          <Col :xs="24" :sm="24" :md="24" :lg="14">
            <div @click="showDrawer(doc.id)" style="cursor: pointer">
<!--            <router-link-->
<!--              :to="{ name: 'product_order_detail', params: { id: doc.id } }"-->
<!--            >-->
              <h3>
                <Tooltip :content="applied_display(doc)" placement="right-end">
                  <Icon v-if="doc.applied" type="ios-arrow-dropdown-circle" color="#25D77E" ></Icon>
                  <Icon v-else type="ios-warning" color="#EF6E57"></Icon>
                </Tooltip>
                <!--<Icon type="md-cash" color="#646363" size="18"/>-->
                <Tooltip content="Товарный документ" placement="right-end">
                  <Icon type="ios-cart" color="#DEDEDE"/>
                </Tooltip>

                {{ doc.name }}
                <!--<Tag-->
                  <!--v-if="doc.applied"-->
                  <!--color="success"-->
                  <!--style="margin-left: 15px;"-->
                  <!--&gt;проведен</Tag-->
                <!--&gt;-->
                <!--<Tag v-else color="warning" style="margin-left: 15px;"-->
                  <!--&gt;не проведен</Tag-->
                <!--&gt;-->
              </h3>
<!--            </router-link>-->
            </div>
            <Tag v-if="doc.category_display">{{ doc.category_display }}</Tag>
            <p style="font-size: 14px; margin-top: 5px; color: rgba(14,37,74,0.5)">{{ formatDateTime(doc.order_date) }}</p>
          </Col>
            <!-- <Col :xs="24" :sm="24" :md="24" :lg="3" style="text-align: right" v-if="debt_status">
              <slot name="closedStatus" :doc="doc"></slot>
            </Col> -->
            <Col :xs="24" :sm="24" :md="24" :lg="debt_status ? 3 : 10" v-if="total_sum_attr(doc.type).sign" style="text-align: right;">
              <h3 v-if="debt_status" style="margin-top: 11px;">
                <span v-if="doc.is_closed" :style="{ color: total_sum_attr(doc.type).color }">закрыт</span>
                <span v-else style="color: red">
                  {{ "-" }}{{ formatNumber(doc.debt_value) }} {{ currency }} 
                </span>
              </h3>
              <h3 v-else :style="{ color: total_sum_attr(doc.type).color }">
                {{ total_sum_attr(doc.type).sign 
                }}{{ formatNumber(doc.total_sum) }} {{ currency }}
              </h3>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7" style="text-align: right;" v-if="debt_status">
              <slot name="repaymentForm" :doc="doc"></slot>
            </Col>
        </Row>
      </Card>
      <Button
        v-show="
          product_orders.current_page * product_orders.limit <
            product_orders.total_records
        "
        style="width: 100%"
        type="info"
        @click="product_orders.current_page++"
        >Показать еще</Button
      >
    </div>
    <Spin size="large" fix v-if="product_orders.loading"></Spin>
    <drawersCommonDocs :item="drawerItem"></drawersCommonDocs>
  </div>
</template>

<script>
import { base_url, server_addr } from "../../http.js";
import {formatDate, formatDateTime, formatNumber} from "../../base/base_func";
import { TYPE_SELL, TYPE_DEBT_SELL, TYPE_PURCHASE, TYPE_RETURN_SELL, TYPE_RETURN_PURCHASE, TYPE_CHANGES_IN, TYPE_CHANGES_OUT, TYPE_MOVING } from '../../apps/product_order/const.js';
import drawersCommonDocs from "@/apps/partial/drawers_docs.vue";
// import drawersCommon from "../../apps/partial/drawers";

export default {
  name: "recentProductOrders",
  debt_status: false,
  props: {
    filter_by: String,
    filter_by_id: [Number, String],
    extra_param: String,
    extra_param_value: [Number, String],
    debt_status: Boolean
  },
  components: {
    drawersCommonDocs
  },
  data() {
    return {
      product_orders: {
        data: [],
        total_records: 0,
        last_draw: 0,
        loading: true,
        current_page: 1,
        limit: 10
      },
      drawerItem: {
        show: false,
        id: null,
        type: null
      },
    };
  },
  computed: {
    currency() {
      return this.$store.state.currency;
    }
  },
  methods: {
    applied_display(doc) {
      return doc.applied ? "Проведен": "Не проведен";
    },

    total_sum_attr: function(doc_type) {
      let sign = "";
      let color = "";

      if (doc_type === TYPE_SELL || doc_type === TYPE_DEBT_SELL) {
        sign = "+";
        color = "#25D77E";
      } else if (doc_type === TYPE_PURCHASE) {
        sign = "-";
        color = "#EF6E57";
      } else if (doc_type === TYPE_RETURN_SELL) {
        sign = "-";
        color = "#EF6E57";
      } else if (doc_type === TYPE_RETURN_PURCHASE) {
        sign = "+";
        color = "#25D77E";
      }
      // else if (doc_type === "changes_in") {
      //   sign = "+";
      //   color = "green";
      // } else if (doc_type === "changes_out") {
      //   sign = "+";
      //   color = "green";
      // } else if (doc_type === "moving") {
      //   sign = "+";
      //   color = "green";
      // } else if (doc_type === "changes_inventory") {
      //   sign = "+";
      //   color = "green";
      // }

      return { sign, color };
    },

    fetchProductOrders: function() {
      const url = base_url + "/product_orders/";
      this.product_orders.loading = true;
      this.product_orders.last_draw++;

      let params = {
        format: "table",
        draw: this.product_orders.last_draw,
        offset:
          this.product_orders.limit * this.product_orders.current_page -
          this.product_orders.limit,
        limit: this.product_orders.limit,
        product: this.id
      };

      params[this.filter_by] = this.filter_by_id;
      params[this.extra_param] = this.extra_param_value;

      this.$http
        .get(url, { params: params })
        .then(result => {
          if (result.data.draw === this.product_orders.last_draw) {
            for (let doc of result.data.results) {
              this.product_orders.data.push(doc);
            }
            this.product_orders.total_records = result.data.count;
          }
        })
        .catch(error => {
          this.$Message.error("Произошла ошибка");
        })
        .then(() => {
          this.product_orders.loading = false;
        });
    },

    // set_initial_product_orders: function() {
    //   this.product_orders = {
    //     data: [],
    //     total_records: 0,
    //     last_draw: 0,
    //     loading: true,
    //     current_page: 1,
    //     limit: 10
    //   };
    // },

    // Форматирование
    formatNumber (number) {
      return formatNumber(number);
    },
    formatDate (date) {
      return formatDate(date);
    },
    formatDateTime  (datetime) {
      return formatDateTime(datetime);
    },
    showDrawer(doc_id) {
      this.drawerItem = {
        show: true,
          id: doc_id,
          type: 'product_order'
      };
    }
},
  mounted() {
    this.fetchProductOrders();
  },

  // Скроллинг документов
  watch: {
    "product_orders.current_page": function() {
      this.fetchProductOrders();
    }
  }
};
</script>

<style scoped>
.ls_empty_list {
  text-align: center;
  font-size: 24px;
  color: rgba(191, 191, 191, 0.87);
  margin: 60px 0;
}
.ls_card {
  width: 100%;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/core/recentProductOrders.vue